module.exports = __webpack_public_path__ + "static/media/bin.ae050d20.svg";